import request from './request';

export default {
	async downloadEquipmentReports(query) {
		const queryStringArr = [];
		if(query) {
			Object.keys(query).map(key => {
				queryStringArr.push(`${key}=${query[key]}`);
				return key;
			});
		}
		const res = await request.post(`/admin/reports/usage-history?${queryStringArr.join('&')}`);
		return res;
	}
};
